import {Moment} from 'moment-timezone';

export function compareMoments(a: Moment, b: Moment, nullFirst: boolean = true) {
  if (a) {
    if (b) {
      if (a.isBefore(b)) {
        return -1;
      } else if (a.isAfter(b)) {
        return 1;
      } else {
        return 0;
      }
    } else {
      return nullFirst ? 1 : -1;
    }
  } else if (b) {
    return nullFirst ? -1 : 1;
  } else {
    return 0;
  }
}

export function momentsEqual(a: Moment, b: Moment): boolean {
  return (a == null && b == null) || (a != null && b != null && a.isSame(b));
}
